import React from 'react';
import { Carousel } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { ContainerType } from '../Models/Enum';
import { IMAGE_MAIN_ENDPOINT } from '../constant';




function BannerCarousel({ data }) {


    if (data != undefined && data.length > 0) {
        var OrderedBanner = data.sort((a, b) => a.ZOrder - b.ZOrder);
    }

    function createMarkup(html) {
        return { __html: html };
    }


    return (
        // <div className='row home mb-5 pb-0 pb-lg-5'>
        //     <div className='col p-0'>
        //         {/* <Carousel data-bs-theme="dark" >
        //             {data != undefined && data.length > 0 && data.map((e, i) => {
        //                 return (
        //                     <Carousel.Item key={i}>
        //                         <img className='img-fluid w-100 ' src={IMAGE_MAIN_ENDPOINT + (e.Image != undefined && e.Image != null && e.Image)} />
        //                         <Carousel.Caption className='d-flex flex-column justify-content-center h-100 pt-0 pb-0' style={{ top: 0, bottom: 0 }}>
        //                             <div>
        //                                 <h1 className='pb-0 pb-lg-2'>{e.Title != undefined && e.Title != null && e.Title}</h1>
        //                                 <div dangerouslySetInnerHTML={createMarkup(e.SubHeading)} />
        //                                 <a className='d-none d-lg-block' href={e.link != undefined && e.link != null && e.link} target='_blank'><div className='d-inline-flex justify-content-center mt-4'> <Button className='me-2 rounded-pill blackButton fw-bold ' >Learn More</Button> </div></a>
        //                                 <a className='d-sm-block d-lg-none' href={e.link != undefined && e.link != null && e.link} target='_blank'><div className='d-inline-flex justify-content-center'>  <Button className='me-2 rounded-pill blackButton fw-bold ' >Learn More</Button> </div></a>
        //                             </div>
        //                         </Carousel.Caption>
        //                     </Carousel.Item>
        //                 )

        //             })}
        //         </Carousel> */}

              
        //     </div>
        // </div>
        <div className='row mb-5 newHomeBanner'>
            <div className='col p-0'>
              
            <Carousel>
            {data != undefined && data.length > 0 && data.map((e, i) => {
                return(
                    <Carousel.Item key={i}>
                        <div className='row justify-content-center align-items-center' style={{ backgroundColor: '#ffe2c7' }}>
                            <div className='col-12 col-lg p-0'>
                                
                                <img className='img-fluid w-100 ' src={IMAGE_MAIN_ENDPOINT + (e.Image != undefined && e.Image != null && e.Image)} />
                            </div>
                            <div className='col-12 col-lg mb-5 pt-4 pt-xl-0 ps-4 ps-lg-0 pe-4 pe-lg-0 ' >
                                <div className='homeBannerHeading'>
                                <h1 className='pb-4 pb-lg-3'>{e.Title != undefined && e.Title != null && e.Title}</h1>
                                <div className='pb-4 pb-lg-2 pb-xl-4 homeSubheading' dangerouslySetInnerHTML={createMarkup(e.SubHeading)} />
                                  
                                    <Button className='me-2 rounded-pill blackButton mb-4 mb-xl-0 ' >Learn More</Button>
                                </div>

                            </div>
                        </div>
                    </Carousel.Item>
                )
            })}
                </Carousel>
            </div>

            

        </div>
    );
}

export default BannerCarousel; 